<template>
  <v-card>
    <vue-card-title
        :title="'Client Log'"
        :subtitle="'Client Log'"
        icon="mdi-file-document-outline"
        closable
        @close="close"
    ></vue-card-title>
    <v-divider></v-divider>
    <v-row class="text-center mx-5">
      <v-col v-for="(stats, index) in clientStats" :key="index" md="4" cols="6">
        <v-card>
          <v-card-text>
            <h5>{{ stats.name }}</h5>
            <h5 v-if="![3,4,5].includes(index)" class="font-6 grey--text">
              NRs. {{ stats.amount || 0 }}
            </h5>
            <h5 class="font-6 grey--text">
              <span v-if="[3,4,5].includes(index)">
                <template v-if="index===4 && stats.data">
                       {{ $dayjs(stats.data).format('YYYY-MM-DD') || 'N/A' }}
                                   <div

                                       :class="
                            getLastCommunicated(stats.data)
                              .color + ' font-weight-bold'
                          "
                                       v-text="
                            getLastCommunicated(stats.data)
                              .text
                          "
                                   ></div>

                </template>
                <span v-else>
                                {{ stats.data || 'N/A' }}
                </span>
              </span>
              <span v-else>
                ({{ stats.data || 'N/A' }})
              </span>
            </h5>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>
<script>
export default {
  data(){
    return{
      clientStats: [
        { name: "Opportunities", data: "",  amount:0 },
        { name: "Lead", data: "", amount:0 },
        { name: "Deal", data: "", amount:0 },
        { name: "Total Communications", data: "" },
        { name: "Last Communicated", data: ""},
        { name: "Latest Service Taken", data: ""},
      ],
    }
  },
  props:{
    slug:{
      type: String,
      required: true
    }
},
  created() {
    this.fetchData()
  },
  methods:{
    humanizeDate(timeStamp) {
      return this.$dayjs(timeStamp).fromNow();
    },
    getLastCommunicated(timeStamp) {
      if (!timeStamp) return { color: "red--text", text: "N/A" };
      const daysObject = {
        30: "green--text",
        60: "blue--text"
      };
      for (const day in daysObject) {
        if (
            this.$dayjs(timeStamp).isAfter(this.$dayjs().subtract(day, "days"))
        ) {
          return { color: daysObject[day], text: this.humanizeDate(timeStamp) };
        }
      }
      return { color: "red--text", text: this.humanizeDate(timeStamp) };
    },
    fetchData(){
      this.$axios.$get(`/api/v1/crm/clients/${this.slug}/`).then(response=>{
        this.clientStats[0].data=response.total_opportunities
        this.clientStats[0].amount=response.total_opportunity_amount
        this.clientStats[1].data=response.total_leads
        this.clientStats[1].amount=response.total_lead_amount
        this.clientStats[2].data=response.total_deals
        this.clientStats[2].amount=response.total_deal_amount
        this.clientStats[3].data=response.total_communications
        this.clientStats[4].data = response.last_communicated
        this.clientStats[5].data = response.latest_service_taken_name
      })
    },
    close(){
      this.$emit('close-view')
    }
  }
}
</script>

<style scoped>

</style>